import {
  createNewStripeCustomer,
  createNewStripeSubscription,
  fetchCurrentCustomer as fetchCurrentCustomerServer,
  fetchSubscriptionPortal as fetchSubscriptionPortalServer,
  createNewCheckoutSession as createNewCheckoutSessionServer,
  getPricing as getPricingServer,
} from '@/actions/customer';
import { Address } from '@/actions/dtos/location';
import { PaymentMethod, SubscriptionTier } from '@/actions/dtos/subscription';
import { BillingPeriod } from '@/types/billingPeriod';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export interface CustomerParams {
  name: string;
  email: string;
  taxId?: string;
  note?: string;
  address: Partial<Address>;
}

export interface SubscriptionParams {
  paymentInterval: BillingPeriod;
  subscriptionTier: SubscriptionTier;
  discountCode?: string;
  paymentMethod: PaymentMethod;
}

export interface StripeCustomerSubscriptionParams {
  customer: CustomerParams;
  subscription: SubscriptionParams;
}

export const getCurrentCustomer = async () => {
  const userAccessToken = await getUserAccessToken();
  return fetchCurrentCustomerServer(userAccessToken);
};

export const getCustomerPortalLink = async (redirectUrl: string) => {
  const userAccessToken = await getUserAccessToken();
  return fetchSubscriptionPortalServer(userAccessToken, redirectUrl);
};

export const createStripeCustomer = async (customerData: CustomerParams, customerId: string) => {
  const userAccessToken = await getUserAccessToken();
  return createNewStripeCustomer(userAccessToken, customerData, customerId);
};

export const createStripeSubscription = async (subscriptionData: SubscriptionParams, customerId: string) => {
  const userAccessToken = await getUserAccessToken();
  return createNewStripeSubscription(userAccessToken, subscriptionData, customerId);
};

export const createNewCheckoutSession = async (tier: SubscriptionTier, period: BillingPeriod, discount?: string) => {
  const userAccessToken = await getUserAccessToken();
  return createNewCheckoutSessionServer(userAccessToken, tier, period, discount);
};

export const getPricing = async (stripeData: StripeCustomerSubscriptionParams) => {
  const userAccessToken = await getUserAccessToken();
  return getPricingServer(userAccessToken, stripeData);
};
